import React, { useMemo, useState } from 'react';
import { Col, Layout, Row, Tabs } from 'tea-component';
import NewsVolumeAndSentiment from './widgets/NewsVolumeAndSentiment';
import RecentTopNews from './widgets/RecentTopNews';
import ChannelChart from './widgets/ChannelChart';
import CountryChart from './widgets/CountryChart';
import LanguageChart from './widgets/LanguageChart';
import BubbleCommon, {
  newsKeywordTips,
  newsTitleText,
} from '../../components/BubbleCommon';
import { connect, useIntl } from 'umi';
import FilterBoxCommon from '../../components/FilterBoxCommon';
import { FilterFixed, useFilterDataHook } from '../../components/FilterCommon';
import CardLoading from '../../components/CardLoading';
import KeywordCard from '../Performance/components/TopicKeyword/KeywordCard';
import { useInitBuriedPointInfo } from '../../operationLog/buriedPoint';
import NewsPoint from '@op/operationLog/pages/news';
import ContentBody from '../../components/ContentBody';
import { PAGE_NAME } from '@op/constants/page';
import { filterIEGGPr } from './hooks/useNewsInfo';
import useTabHistory from '@op/hooks/useTabHistory';
import { POE2 } from '@op/constants/specialGame';
import TextBubbles from '@home/components/TextBubbles';
import levelInfinite from '@/pages/opinion/assets/svg/logo-level-infinite.svg';
import DashboardReport from '@op/components/DashboardReport';
import './index.scss';
import { DBO_TM } from '@op/utils/format';

const { Content } = Layout;
type TabType = string;

function News({ gameInfo }: any) {
  const { formatMessage } = useIntl();
  const isPOE2 = POE2.includes(gameInfo?.edition_unified_id);
  const { scrollBody, loading, filter, changeFilter, filterOptions } =
    useFilterDataHook({
      pageName: 'Stats_News',
    });
  useInitBuriedPointInfo({ buriedPoint: NewsPoint });
  const { showIEGGPr, backCond, renderExcludeFilter } = filterIEGGPr();
  const [dataSourceList, setDataSourceList] = useState<string[]>([]);
  const tabs = useMemo(() => {
    const tabs = [
      {
        id: 'news',
        label: (
          <div className={'dbo-channellabel'}>
            <TextBubbles
              rowNum={1}
              className={`dbo-channellabel-text`}
              text={formatMessage({ id: 'News' })}
            />
          </div>
        ),
      },
      {
        id: 'iegg',
        label: (
          <div className={'dbo-channellabel'}>
            <img src={levelInfinite} width={16} height={16}></img>
            <TextBubbles
              rowNum={1}
              className={`dbo-channellabel-text`}
              text={formatMessage({ id: 'IEGG PR' })}
            />
          </div>
        ),
      },
    ];

    return isPOE2 ? tabs : [];
  }, [formatMessage, isPOE2]);

  const { tab, onActive } = useTabHistory<TabType>({
    defaultValue: 'news',
  });

  return (
    <Content ref={scrollBody}>
      <ContentBody
        pageName={PAGE_NAME.NEWS}
        contentHeard={
          <Content.Header
            title={formatMessage({ id: PAGE_NAME.NEWS })}
            className={`dbo-news-header ${isPOE2 ? 'contentHead-normal' : ''}`}
            subtitle={
              <div className="dbo-header-subtitle ">
                {formatMessage({ id: 'Data Update' })}
                <BubbleCommon tipsMap={newsTitleText}></BubbleCommon>
              </div>
            }
          >
            {isPOE2 && (
              <div className="header-tab feeds-header-tab">
                <Tabs
                  ceiling
                  tabs={tabs}
                  animated={false}
                  activeId={tab}
                  onActive={(tab) => onActive(tab)}
                />
              </div>
            )}
          </Content.Header>
        }
      >
        {/* 头部筛选组件 */}
        {tab === 'news' ? (
          <>
            <FilterFixed
              backCondOriginData={(options) => {
                setDataSourceList(options?.news_data_source || []);
                backCond(options);
              }}
              filter={filterOptions}
              renderExcludeFilter={renderExcludeFilter}
              // operateShowOptions={['more']}
              defaultValue={DBO_TM.utcFilterRangeDay(30, 0)}
              defaultConfig={{
                channel: {
                  channelKey: 'news',
                },
              }}
              confirm={(value?: any) => {
                changeFilter({
                  ...value,
                  ...gameInfo,
                  social_media_by_account: ['99999'],
                  social_media_by_keyword: ['99999'],
                  external_data_sources: ['99999'],
                });
              }}
              scrollBody={scrollBody}
            ></FilterFixed>
            <CardLoading loading={loading}>
              {/* 新闻头部信息展示 */}
              <NewsVolumeAndSentiment
                params={filter}
                showIEGGPr={showIEGGPr}
                dataSourceList={dataSourceList}
              ></NewsVolumeAndSentiment>

              {/* 表单 */}
              <RecentTopNews params={filter}></RecentTopNews>

              {/* 图表 */}
              <Row gap={20} className="dbo-news-chart-box">
                {/* 一期展示隐藏 */}
                <Col span={12}>
                  <KeywordCard
                    className="dbo-news-keyword-card"
                    wordCloudChartHeight={284}
                    hasTitleArrow={false}
                    title={
                      <BubbleCommon tipsMap={newsKeywordTips}>
                        {formatMessage({ id: 'Keyword' })}
                      </BubbleCommon>
                    }
                    contentCard={false}
                    filter={filter}
                    curFilter="0"
                    chartClickAble={false}
                  ></KeywordCard>
                </Col>

                <Col span={12}>
                  <ChannelChart
                    params={filter}
                    defaultType="sentiment-h-bar"
                  ></ChannelChart>
                </Col>

                <Col span={12} style={{ marginBottom: 10 }}>
                  <CountryChart
                    regionKind="market"
                    params={filter}
                  ></CountryChart>
                </Col>
                <Col span={12}>
                  <LanguageChart params={filter}></LanguageChart>
                </Col>
              </Row>
            </CardLoading>
          </>
        ) : (
          <DashboardReport
            id={'42f3d054249e675ba47e453d1115a623'}
            className={'dbo-news-report'}
            pageName={'News'}
            pageId={'20103'}
          />
        )}
      </ContentBody>
    </Content>
  );
}
export default connect((state: { opinionCommon: any }) => {
  const { opinionCommon } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
  };
})(News);
